module.exports = __webpack_public_path__ + "static/media/movies-asset1.57c504c1.svg";